<template>
  <div class="card">
    <div class="card-body">
      <h3 class="summary-title">สรุปคำสั่งซื้อ</h3>
      
      <div class="summary-rows">
        <div class="summary-row">
          <span>ยอดรวมสินค้า</span>
          <span>{{ formatPrice(subtotal) }}</span>
        </div>
        <div class="summary-row">
          <span>ค่าจัดส่ง</span>
          <span>{{ formatPrice(shippingFee) }}</span>
        </div>
        <div class="summary-row total">
          <span>ยอดสุทธิ</span>
          <span>{{ formatPrice(total) }}</span>
        </div>
      </div>

      <button 
        @click="$router.push('/checkout')"
        class="btn btn-primary w-full"
        :disabled="disabled || subtotal <= 0"
      >
        ดำเนินการชำระเงิน
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  subtotal: { type: Number, default: 0 },
  shippingFee: { type: Number, default: 0 },
  total: { type: Number, default: 0 },
  disabled: { type: Boolean, default: false }
});

const formatPrice = (price) => {
  const num = parseFloat(price) || 0;
  return new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(num);
};
</script>

<style scoped>
.summary-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 1.5rem;
}

.summary-rows {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  color: var(--color-text-light);
  font-size: 0.9375rem;
}

.summary-row.total {
  border-top: 1px solid var(--color-border);
  padding-top: 0.75rem;
  font-weight: 700;
  font-size: 1.125rem;
  color: var(--color-text);
}
</style>
